"use client";

import styled from "styled-components";
import PropTypes from "prop-types";
import { spacing16 } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
const Root = styled.div.withConfig({
  componentId: "sc-nddjfn-0"
})(["padding:0 ", ";"], spacing16);
const Content = styled.div.withConfig({
  componentId: "sc-nddjfn-1"
})(["max-width:42rem;margin:0 auto;"]);

/**
 * Wrapping element that constrains the width of content to a size appropriate to reading text.
 */
const ReadWidth = ({
  children,
  ...props
}) => /*#__PURE__*/_jsx(Root, {
  ...props,
  children: /*#__PURE__*/_jsx(Content, {
    children: children
  })
});
ReadWidth.displayName = "ReadWidth";
ReadWidth.propTypes = {
  /** Children to be constrained */
  children: PropTypes.node.isRequired
};
export default ReadWidth;